import * as React from "react";

import { cn } from "@/lib/utils";
import { NavLink } from "react-router-dom";

export interface NavTabsProps extends React.HTMLAttributes<HTMLDivElement> {}

const NavTabs = React.forwardRef<HTMLDivElement, NavTabsProps>(({ className, ...props }, ref) => (
    <div ref={ref} className={cn("inline-flex h-9 items-center justify-center rounded-lg bg-gray-100 p-1 text-muted-foreground", className)} {...props} />
));

const NavTabItem = React.forwardRef<React.ElementRef<typeof NavLink>, React.ComponentPropsWithoutRef<typeof NavLink>>(({ className, ...props }, ref) => (
    <NavLink
        replace
        ref={ref}
        className={({ isActive }) =>
            cn(
                "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
                isActive ? "bg-background text-foreground shadow" : "",
                className
            )
        }
        {...props}
    />
));

export { NavTabItem, NavTabs };
